import {shallowEqual, useSelector} from "react-redux";

export const getProbeSummary = (data, live) => {
  try {
    let newSellPriceYes, newSellPriceNo;
    let calls = data?.calls ?? [];

    if (!data?.["is_price_editable"]) {
      newSellPriceYes = live?.exPriceYes ?? data.newSellPriceYes;
      newSellPriceNo = live?.exPriceNo ?? data.newSellPriceNo;
    } else {
      newSellPriceYes = live?.newNCP
        ? 100 - live?.newNCP
        : data.newSellPriceYes;
      newSellPriceNo = live?.newYCP ? 100 - live?.newYCP : data.newSellPriceNo;
    }
    if (newSellPriceYes === undefined && newSellPriceNo === undefined) {
      data.veryLowHolding = true;
      return data;
    }
    const generateSummary = (summary, call) => {
      let {
        investment,
        totalCurrentValue,
        totalCurrentValueNull,
        openOrderValue,
      } = summary;
      if (call.rank === -1 && call.status === "H") {
        // investment += call.noofcontracts * call.lastprice;
        // const currentPrice =
        //   call.callvalue === 'Y' ? newSellPriceYes : newSellPriceNo;
        // totalCurrentValue += call.noofcontracts * currentPrice;
        // totalCurrentValue += call.noofcontracts * ;
        openOrderValue += call.noofcontracts * call.lastprice;
      } else if (
        call.rank === 0 &&
        call.status === "A" &&
        call.callvalue === "Y" &&
        newSellPriceYes !== undefined
      ) {
        investment += call.noofcontracts * call.coins;
        if (newSellPriceYes === null) {
          totalCurrentValueNull = true;
        }
        totalCurrentValue += call.noofcontracts * newSellPriceYes;
      } else if (
        call.rank === 0 &&
        call.status === "A" &&
        call.callvalue === "N" &&
        newSellPriceNo !== undefined
      ) {
        investment += call.noofcontracts * call.coins;
        if (newSellPriceNo === null) {
          totalCurrentValueNull = true;
        }
        totalCurrentValue += call.noofcontracts * newSellPriceNo;
      } else if (call.rank === -1 && call.status === "A") {
        // const currentPrice =
        //   call.callvalue === 'Y' ? newSellPriceYes : newSellPriceNo;
        // investment += call.noofcontracts * call.coins;
        // totalCurrentValueNull = true;
        // if (currentPrice) {
        //   totalCurrentValue += call.noofcontracts * call.coins;
        // }
        openOrderValue += call.noofcontracts * call.coins;
      }
      return {
        totalCurrentValue,
        investment,
        totalCurrentValueNull,
        openOrderValue,
      };
    };
    const summary = calls.reduce(generateSummary, {
      investment: 0,
      totalCurrentValue: 0,
      totalCurrentValueNull: false,
      openOrderValue: 0,
    });
    const item = {
      ...data,
      newYCP: live?.newYCP ?? data?.currentPrice?.newYCP,
      newNCP: live?.newNCP ?? data?.currentPrice?.newNCP,
      currentPrice: {
        newYCP: live?.newYCP ?? data?.currentPrice?.newYCP,
        newNCP: live?.newNCP ?? data?.currentPrice?.newNCP,
      },
      newSellPriceYes: newSellPriceYes,
      newSellPriceNo: newSellPriceNo,
      summary: [
        {
          label: "Investment",
          value: `${summary.investment.toFixed(2)}`,
        },
        {
          label: "Current Value",
          value: `${summary.totalCurrentValue.toFixed(2)}`,
        },
        {
          label: "Profit or Loss",
          value:
            summary.totalCurrentValueNull && summary.totalCurrentValue <= 0
              ? "- "
              : (
                  ((summary.totalCurrentValue - summary.investment) /
                    (summary.investment || 1)) *
                  100
                ).toFixed(2),
        },
        {
          label: "No Matching Order",
          value: summary.totalCurrentValueNull,
        },
        {
          label: "Open Order Value",
          value: summary.openOrderValue,
        },
      ],
    };
    return item;
  } catch (e) {
    return data;
  }
};

export const selectLiveProbes = (portfolioReducer, liveReducer, state) => {
  var portfolio = state;
  if (portfolio) {
    let livePortfolio = portfolioReducer?.data1;
    portfolio = livePortfolio[portfolio];
    let live = {
      ...(liveReducer?.byIds?.[portfolio.id] || {}),
    };
    let probes = getProbeSummary(portfolio, live);

    // const veryLowHoldingLiqudity = probes
    //   .filter(i => i.veryLowHolding && i.liquidity)
    //   .map(i => i.liquidity);

    // const filteredProbes = probes.filter(i => !i.veryLowHolding);
    return {
      probes: probes,
      //liquidity: (portfolio?.liquidity ?? []).concat(veryLowHoldingLiqudity),
    };
  } else {
    return {
      probes: null,
    };
  }
};
